import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { TiTicket } from 'react-icons/ti';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
};

function EventStatus({ event }) {
  if (!event.has('tickets')) return null;
  const noAvailableTickets = event
    .get('tickets')
    .every(n => n.get('on_sale_status') === 'UNAVAILABLE');
  const status = noAvailableTickets ? 'Postponed' : 'On Sale';
  return (
    <div style={{ display: 'flex', marginRight: 10 }}>
      <TiTicket size={25} style={{ marginRight: 5 }} />
      <div className={`event-status-${noAvailableTickets ? 'unavailable' : 'available'}`}>
        {status}
      </div>
    </div>
  );
}

EventStatus.propTypes = propTypes;

export default EventStatus;



// WEBPACK FOOTER //
// ./src/widget/event_components/event_status.js